import { Component, OnInit } from '@angular/core';
import { AbstractControl, Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LayoutService } from 'src/app/layout/layout.service';
import { ThirdPartyService } from '../../third-party.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm!: FormGroup;
  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;
  branchInfo: any;
  loading: boolean = false;

  constructor(
    public layoutService: LayoutService,
    private fb: FormBuilder,
    private thirdPartyService: ThirdPartyService,
  ) { }

  ngOnInit(): void {
    this.populateToolbarData();
    this.setAllForms();
    this.getUserAndBranchID();
  }

  private setAllForms() {
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    }, {
      validators: this.passwordMatchValidator
    });
  }

  // Custom validator for confirming password
  passwordMatchValidator(form: AbstractControl) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;

    if (!confirmPassword) {
      return null; // don't show mismatch when confirmPass is empty
    }

    if (newPassword !== confirmPassword) {
      form.get('confirmPassword')?.setErrors({ mismatch: true });
    } else {
      // remove only the mismatch error
      if (form.get('confirmPassword')?.hasError('mismatch')) {
        form.get('confirmPassword')?.setErrors(null);
      }
    }

    return null;
  }


  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 3000);
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Change Password',
    });

    this.layoutService.setNavbarButtons([]);
  }

  private getUserAndBranchID() {
    this.thirdPartyService.getStaffIdAndBrandchId().subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData) {
        let response = res?.ResponseData;
        this.branchInfo = response;
      }
    }, (error: HttpErrorResponse) => {
    });
  }

  public submit() {
    this.loading = true;
    if (this.changePasswordForm.invalid) {
      this.changePasswordForm.markAllAsTouched();
      return;
    }

    let params = {
      userId: this.branchInfo?.UserId,
      oldPassword: this.changePasswordForm.get('oldPassword')?.value,
      newPassword: this.changePasswordForm.get('newPassword')?.value,
    }

    this.thirdPartyService.updateBranchUserPassword(params).subscribe((res: any) => {
      if (res && res?.Result == "Success" && res?.ResponseData == 'Success') {
        this.notify(true, 'Password changed successfully.');
        this.changePasswordForm.reset();
      } else if (res && res?.Result == "Success" && res?.ResponseData == 'No User') {
        this.changePasswordForm.get('oldPassword')?.setErrors({ invalidOldPassword: true });
        this.changePasswordForm.get('oldPassword')?.markAsTouched();
        this.notify(false, 'Old password is incorrect.');
      } else {
        this.notify(false, 'Failed to change password. Please try again.');
      }
      this.loading = false;
    }, (err: any) => {
      this.notify(false, 'Failed to change password. Please try again.');
      this.loading = false;
    })
  }

}
